import React from 'react'
import Form from './container'
import PageTemplate from 'components/page-template'

export default () => (
  <PageTemplate
    title='Create a ThreadVenture Experience'
    description="that's where the automagic happens"
    className='br-experience widgetBuilder'
  >
    <Form experiencePlatform={'twitter'} experienceType={'threadVenture'} />
  </PageTemplate>
)



// WEBPACK FOOTER //
// ./src/pages/widgets/thread_venture/create/index.js